import React, {useEffect } from 'react'; 
import Header from '../Component/Header';
import Footer from '../Component/Footer'; 
import { Link } from 'react-router-dom';
function ManagingCommittee() { 
  useEffect(() => {
    document.title = 'ManagingCommittee-  CARMEL CONVENT SCHOOL, DHARUHERA';  
}, []); 
  return (
    <>   
      <Header />
      <div className="sliderbg"></div>
      <div className="innerpage">
        <div className="container">
          <div className="row">
            <div className="col-12">
              <ul className="breadcrumbli">
                <li><Link to="/"> Home </Link></li>
                <li> About Us</li>
                <li>Managing Committee</li>
              </ul>
            </div> 
            <div className="col-lg-12">
              <h2 className="innerheading">Managing Committee</h2>
            </div>
          </div> 
          <div className="row">
               <div className="col-lg-12">
               <div class="table-responsive maintable">
               <table class="table">
                   <thead>
                       <tr>
                           <th>Sr. No.</th>
                           <th>Name</th>
                           <th>Designation</th>
                       </tr>
                   </thead>
                   <tbody>
                       <tr><td> 1 </td> <td> Sr. Mary Supreeta </td> <td> Principal <br/> Carmel Convent School, Dharuhera </td> </tr>
                       <tr><td> 2 </td> <td> Sr. Maria Meeta </td> <td> Manager <br/> Carmel Convent School, Dharuhera </td> </tr>
                       <tr><td> 3 </td> <td> Sr. Rita Gill </td> <td> Member <br/> Carmel Convent School, Dharuhera </td> </tr>
                       <tr><td> 4 </td> <td> Sr. Mary Sushma (Educationist) </td> <td> Member <br/> Carmel Convent, Chanakyapuri, New Delhi </td> </tr>
                       <tr><td> 5 </td> <td> Sr. Elica Rebello (Educationist) </td> <td> Member <br/> Carmel Convent, Chanakyapuri, New Delhi </td> </tr>
                       <tr><td> 6 </td> <td> Mrs. Pooja Yadav (Teacher) </td> <td> Member </td> </tr>
                       <tr><td> 7 </td> <td> Mrs. Suman (Parent) </td> <td> Member </td> </tr>
                   </tbody>
               </table>
           </div>
              </div>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
}

export default ManagingCommittee;
